import { parseUserAgent } from '@st/utils'
import { usePwaActivity } from '../composables/usePwaActivity'
import { useWebPushStore } from '../stores/useWebPushStore'
import { usePwaDeps } from '../useDeps'

export default defineNuxtPlugin({
  name: 'webPush',
  parallel: true,
  order: 3,
  async setup() {
    const { isPwa } = useApplicationType()
    const { isAuthenticated } = usePwaDeps()
    const webPushStore = useWebPushStore()
    const { firstPwaActivate, wasFirstActivity } = usePwaActivity()
    const { registerConnection, init } = webPushStore
    const { hasSubscription } = storeToRefs(webPushStore)
    const { os } = parseUserAgent()
    const router = useRouter()
    const route = useRoute()
    if (hasSubscription.value && isPwa.value) {
      registerConnection()
    }

    watchEffect(async () => {
      if (isAuthenticated.value && isPwa.value) {
        if (wasFirstActivity.value) return
        await firstPwaActivate()
        if (os === 'ios') {
          router.replace({ query: { ...route.query, modal: 'webPushEnable' } })
        } else {
          await init()
        }
      }
    })
  },
})
